<template>
  <div>
    <div id="commonMap" v-bind:style="mapstyle"></div>
    <div id="myPageTop">
      <table>
        <tr>
          <td colspan="2">
            <label>按关键字搜索：</label>
          </td>
          <!-- <td class="column2">
                          <label>左击获取经纬度：</label>
            </td>-->
        </tr>
        <tr>
          <td colspan="2">
            <input type="text" placeholder="请输入关键字进行搜索" id="tipinput" />
          </td>
          <!-- <td class="column2">
                          <input type="text" readonly="true" id="lnglat">
            </td>-->
        </tr>
      </table>
    </div>
  </div>
</template>

<style lang="less">
  #myPageTop {
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 999;
    background: rgba(255, 255, 255, 0.85);
    padding: 0 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    input {
      width: 100%;
      height: 25px;
      line-height: 32px;
      padding-left: 5px;
    }
  }
  .amap-sug-result {
  z-index: 999999 !important
  }
</style>

<script>
  export default {
    name: "gelLonLatMap",
    props: {
      Lon: null,
      Lat: null
    },
    data() {
      return {
        marker: "",
        map: "",
        // 地图样式
        mapstyle: {
          width: "100%",
          height: "500px",
          borderRadius: "10px"
        }
      };
    },
    methods: {
      // 样式初始化
      initStyle() {
        let height = $(window).height() - 110;
        let width = $(window).width() - 220;
        this.mapstyle.width = width + "px";
        this.mapstyle.height = height + "px";
      },
      init() {
        //输入提示
      },
      emitEvent() {
        this.$emit("handle-click", this.childData);
      },
      // 地图标点
      markerForMap(lng, lat) {
        this.marker = new AMap.Marker({
          position: [lng, lat],
          draggable: true,
          cursor: "move"
        });
        let gpsLon = lng,
          gpsLat = lat;
        // document.getElementById("lnglat").value = gpsLon + ',' + gpsLat;
        AMap.event.addListener(this.marker, "dragend", function() {
          // document.getElementById("lnglat").value = gpsLonUp + ',' + gpsLatUp;
        });
        this.marker.setMap(this.map);
        this.$emit("updateSelLonLat", {
          Lon: lng,
          Lat: lat
        });
      }
    },
    mounted() {
      var _this = this;
      _this.map = new AMap.Map("commonMap", {
        resizeEnable: true,
        center: _this.Lon ? [_this.Lon, _this.Lat] : [120.30071, 31.575789],
        zoom: 20 // 缩放
      });
      _this.marker = new AMap.Marker({
        map: _this.map,
        position: _this.Lon ? [_this.Lon, _this.Lat] : [120.30071, 31.575789], //[_this.Lon,_this.Lat],
        offset: new AMap.Pixel(-13, -30)
      })
      // 为地图注册click事件获取鼠标点击出的经纬度坐标
      var clickEventListener = _this.map.on("click", function(e) {
        _this.map.remove(_this.marker);
        _this.markerForMap(e.lnglat.getLng(), e.lnglat.getLat());
      });
      //输入提示
      var autoOptions = {
        input: "tipinput"
      };
      var auto = new AMap.Autocomplete(autoOptions);
      var placeSearch = new AMap.PlaceSearch({
        map: _this.map
      }); //构造地点查询类
      AMap.event.addListener(auto, "select", select); //注册监听，当选中某条记录时会触发
      function select(e) {
        if (e.poi && e.poi.location) {
          _this.map.setZoom(20);
          _this.map.setCenter(e.poi.location);
          _this.map.remove(_this.marker);
          _this.markerForMap(e.poi.location.lng, e.poi.location.lat);
        }
      }
    }
  };
</script>
